import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import qs from 'qs';
import { post } from '../utils/apiUtilities';

function VerifyCode({ location, setIsAuthenticated }) {
    const queryString = qs.parse(location.search, { ignoreQueryPrefix: true });
    const returnUrl = queryString.ReturnUrl || queryString.returnUrl;
    const token = queryString.token;
    const username = queryString.username;
    const method = queryString.method;
    const methodType = parseInt(queryString.methodType);

    const [code, setCode] = useState('');
    const [rememberDevice, setRememberDevice] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [needsAuthRequestRestarted, setNeedsAuthRequestRestarted] = useState('');
    const [authRequestRestartUrl, setAuthRequestRestartUrl] = useState('');
    const [authRequestRestartMessage, setAuthRequestRestartMessage] = useState('');

    const verify = async (e) => {
        e.preventDefault();
        setIsVerifying(true);

        try {
            const d = await post('account/verifymfa', {
                identifier: token,
                code: code,
                rememberDevice: rememberDevice,
                returnUrl: returnUrl
            });

            //Ensure error message is cleared if Ok is returned from the controller method above.
            setErrorMessage('');

            if (d.needsAuthRequestRestarted) {
                setNeedsAuthRequestRestarted(true);
                setAuthRequestRestartUrl(d.redirect);
                setAuthRequestRestartMessage(d.message);
                return;
            }
            else {
                setNeedsAuthRequestRestarted(false);
            }

            setIsAuthenticated(true);
            window.location.href = d.redirect;
        }
        catch (err) {
            setNeedsAuthRequestRestarted(false);
            setIsVerifying(false);

            if (err && err.responseText) {
                try {
                    const j = JSON.parse(err.responseText);
                    setErrorMessage(j.detail);
                }
                catch {
                    setErrorMessage((err.status === 400 || err.status === 401) ? err.responseText : 'An error occurred while logging in.');
                }
            }

            throw (err);
        }
        finally {
            setIsVerifying(false);
        }
    }

    const message = () => {
        switch (methodType) {
            case 100: // Email
                return `We sent an email to ${method}.`;
            case 101: // SMS
                return `We texted your phone ${method}.`;
            case 102: // Voice
                return `We called your phone ${method}.`;
            case 103: // Authenticator
                return `Enter the code from your authenticator app.`;
            default:
                return `Enter your verification code.`;
        }
    }

    return (
        <>
            <Helmet>
                <title>Sign In | CBRN Network</title>
            </Helmet>
            <div id="layout-shell" className="shell top100">
                <div className="main-content container" id="loginCont" tabIndex="-1">
                    <div className="row">
                        <main>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-md-offset-3 col-lg-offset-3">
                                <form autoComplete="off" className="form-horizontal signin-form" onSubmit={verify}>
                                    {(!needsAuthRequestRestarted ? '' : (
                                        <div className="alert alert-danger">
                                            <p>{authRequestRestartMessage}</p>
                                            <p>Please return to the <a href={authRequestRestartUrl}>login page</a> and restart the authentication process.</p>
                                        </div>
                                    ))}

                                    {(!(errorMessage && errorMessage.length) ? '' : (
                                        <div className="alert alert-danger">
                                            <span dangerouslySetInnerHTML={{ __html: errorMessage }}></span>
                                        </div>
                                    ))}

                                    <div className="panel panel-default">
                                        <div className="panel-body">
                                            <div className="bottom10 bigger-120">{username}</div>

                                            <div className="form-group">
                                                <label className="col-xs-12 required-field-indicator">{message()} Please enter the code to sign in:</label>
                                                <div className="col-xs-12">
                                                    <input className="form-control" value={code} onChange={(e) => setCode(e.target.value)} />
                                                    <span className="field-validation-valid" data-valmsg-for="SelectedExternalLoginProviderValue" data-valmsg-replace="true" />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    <label>
                                                        <input type="checkbox" checked={rememberDevice} onChange={(e) => setRememberDevice(e.target.checked)} />
                                                        &nbsp; Don't ask again for 30 days
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    <button id="loginButtonExternalLoginProvider"
                                                        className="btn btn-success btn-lg btn-block"
                                                        name="button"
                                                        disabled={isVerifying}
                                                        onClick={verify}>
                                                        {isVerifying ? 'Verifying...' : 'Verify'}
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <div className="col-xs-12">
                                                    Having trouble? <a href="#"
                                                        disabled={isVerifying}
                                                        onClick={(e) => { e.preventDefault(); window.history.back(); }}>
                                                        Sign in another way
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </>
    );
}

export default withRouter(VerifyCode);
